module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Medium.4b1f0b7a.ttf";